export interface IFinalizedRequest {
  caseLineItemId: number
  finalizedDate: Date
}

export class FinalizedRequest implements IFinalizedRequest {
  public caseLineItemId: number
  public finalizedDate: Date
}
